<template>
    <div v-if="resource.data">
        <div class="activity-log-wrapper" v-if="resource.data">
            <template v-for="(item,i) in activities">

                <div v-if="Object.keys(item.properties.attributes).length">
                    <a class="activity-log-title" href @click.prevent="toggleProperties(item)" :class="{open: item.expanded}">
                        {{ item.causer ? item.causer.name : 'unknown' }} {{ item.description }}
                        <span v-if="showSubject">{{ item.subject_type }}</span>
                        <i class="activity-log-toggle la la-angle-right"></i>
                    </a>
                    <span class="activity-log-date">{{ toLocal(item.created_at) }}</span>
                </div>
                <div v-else>
                    <span class="activity-log-title">
                        {{ item.causer ? item.causer.name : 'unknown' }} {{ item.description }}
                        <span v-if="showSubject">{{ item.subject_type }}</span>
                    </span>
                    <span class="activity-log-date">{{ toLocal(item.created_at) }}</span>
                </div>
                <div class="activity-log-properties">

                    <div v-for="(value,key) in item.properties.attributes" class="activity-log-item">
                        <div class="activity-log-property">{{ key }}</div>
                        <div class="activity-log-diff clearfix" v-if="item.expanded">
                            <div class="activity-log-diff-item">
                                <pre><code v-if="item.properties.old">{{ getValue(item.properties.old[key]) }}</code></pre>
                            </div>
                            <div class="activity-log-diff-item">
                                <pre><code v-if="value">{{getValue(value)}}</code></pre>
                            </div>
                        </div>
                    </div>
                </div>

            </template>


        </div>
        <div class="text-center">
            <pagination :resource="resource" @load="load"></pagination>
        </div>
    </div>
</template>

<style type="text/css">
.activity-log-toggle {
    font-size: 0.85em;
    transition: all .3s ease;
}

.open .activity-log-toggle {
    transform: rotateZ(90deg);
}

.activity-log-wrapper {
    overflow-x: hidden;
    overflow-y: auto;
    margin-top: 40px;
    margin-bottom: 40px;
    padding: 0 7px;
}

.activity-log-title {
    padding: 0 5px 0 0;
    font-size: 1rem;
}

.activity-log-properties {
    border-left: 1px solid #ccc;
    margin-left: 18px;
}

.activity-log-property {
    font-size: 1rem;
    background: #ccc;
    color: white;
    display: inline-block;
    padding: 1px 5px;
    border-top-right-radius: 2px;
    border-bottom-right-radius: 2px;
}

.activity-log-diff {
    margin-left: 36px;
    font-size: 0.85em;
    margin-top: 4px;
    margin-bottom: 4px;
}

.activity-log-diff-item {
    width: 50%;
    float: left;
}

.activity-log-date {
    font-size: .85rem;
    color: #7b7e8a;
    float: right;
}
</style>

<script>
import axios from 'axios';
import Time from 'lib/Time.js';
export default {
    props: {api: String, showSubject: Boolean},
    mixins: [Time],
    data() {
        return {
            resource: {},
            expanded: []
        };
    },
    watch: {
        api() {
            this.load();
        },
    },
    methods: {
        load(url) {
            url = url || this.api;
            this.resource = {};
            axios.get(url).then(res => {
                this.resource = res.data;
            });
        },
        isJson(something) {
            return typeof something === 'object';
        },
        getValue(value) {
            if (typeof value === 'object') {
                return JSON.stringify(value, null, 4).replace(/^\{((.|\n)*?)\}$/, '$1');
            }
            return value;
        },
        toggleProperties(item) {
            if (this.expanded.includes(item.id)) {
                return this.expanded = this.expanded.filter(x => x != item.id);
            }
            return this.expanded.push(item.id);
        }
    },
    computed: {
        activities() {
            return this.resource.data.map(item => {
                if (item.description === 'created') {
                    item.className = 'm-list-timeline__badge--success';
                } else if (item.description === 'updated') {
                    item.className = 'm-list-timeline__badge--info';
                } else {
                    item.className = 'm-list-timeline__badge--danger';
                }
                item.expanded = this.expanded.includes(item.id);
                return item;
            });
        }
    },
    mounted() {
        this.load();
    }
};
</script>


// WEBPACK FOOTER //
// resources/js/metronic/ActivityLog.vue